import HomeAndCompanies from './homeAndCompanies';

export default HomeAndCompanies;
